module.exports = __webpack_public_path__ + "img/bil.c8b0efc.svg";